import React from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Email from '@mui/icons-material/Email';
import Lock from '@mui/icons-material/Lock';
import Business from '@mui/icons-material/Business';
import Phone from '@mui/icons-material/Phone';
import LocationCity from '@mui/icons-material/LocationCity';
import Public from '@mui/icons-material/Public';
import './style/CreatingUserYuridicheskoyeLitso.css';

function CreatingUserYuridicheskoyeLitso() {

return (
<div className="yur-litso-create-user-container">
  <div className="yur-litso-user-section">
    <h2 className="yur-litso-create-user-title">Регистрация юридического лица</h2>
    <form className="yur-litso-create-user-form">
      <TextField label="Название компании" variant="outlined" fullWidth margin="normal" InputProps={{ startAdornment: <Business className="yur-litso-input-icon" />, }} />
      <TextField label="ИИН" variant="outlined" fullWidth margin="normal" />
      <TextField label="Контактное лицо" variant="outlined" fullWidth margin="normal" InputProps={{ startAdornment: <AccountCircle className="yur-litso-input-icon" />, }} />
      <TextField label="Электронная почта" variant="outlined" fullWidth margin="normal" InputProps={{ startAdornment: <Email className="yur-litso-input-icon" />, }} />
      <TextField label="Телефон" variant="outlined" fullWidth margin="normal" InputProps={{ startAdornment: <Phone className="yur-litso-input-icon" />, }} />
      <TextField label="Юридический адрес" variant="outlined" fullWidth margin="normal" InputProps={{ startAdornment: <LocationCity className="yur-litso-input-icon" />, }} />
      <TextField label="Город" variant="outlined" fullWidth margin="normal" InputProps={{ startAdornment: <Public className="yur-litso-input-icon" />, }} />
      <TextField label="Пароль" type="password" variant="outlined" fullWidth margin="normal" InputProps={{ startAdornment: <Lock className="yur-litso-input-icon" />, }} />
        <Button variant="contained" color="primary" type="submit" className="yur-litso-submit-button">Создать аккаунт</Button>
    </form>
  </div>
</div>
);
}

export default CreatingUserYuridicheskoyeLitso;
